import { apiClient } from './AbstractHTTPService'

const PATH = '/basedata/skill/'

export default {
  getSkills () {
    return apiClient.get(PATH)
  }
}
